import { isNumeric } from '@/shared/lib/utils';

import type { OpdsStyleProps } from './styleProps';
import { stylePropsMap } from './styleProps';

const spacingProps: (keyof OpdsStyleProps)[] = [
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'me',
  'ms',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
  'ps',
  'pe',

  'w',
  'h',
  'maw',
  'mah',
  'miw',
  'mih',

  'fz',
];

const cssUnits = ['em', 'rem', 'px', 'vh', 'vw', 'vmin', 'vmax', '%'];

const convertValue = (key: keyof OpdsStyleProps, value: string | number) => {
  if (spacingProps.includes(key)) {
    if (isNumeric(value)) {
      return `${value}px`;
    }

    if (cssUnits.some((unit) => value.toString().endsWith(unit))) {
      return value;
    }

    return `${Number.parseFloat(value.toString())}px`;
  }

  return value;
};

export const convertStyleProps = (styleProps: OpdsStyleProps) => {
  const styles: Record<string, string | number> = {};

  Object.entries(styleProps).forEach(([key, value]) => {
    if (value !== undefined) {
      const cssProperty = stylePropsMap[key as keyof OpdsStyleProps];
      if (cssProperty) {
        styles[cssProperty] = convertValue(key as keyof OpdsStyleProps, value);
      }
    }
  });

  return styles as React.CSSProperties;
};
